export default "__VITE_ASSET__mXmkyU5z__"